import { Injectable } from '@angular/core';

@Injectable()
export class MenuService {

  constructor() { }

  getMenu(): Array<any> {
    const menu = [
      { name: 'login', path: './login', children: [] },
      { name: 'home', path: '/', children: [] },
      { name: 'home', path: './home', children: [] },
      { name: 'metrics', path: './metrics', children: [] },
      { name: 'clients', path: './clients', children: [] },
      { name: 'applications', path: './applications', children: [] },
      { name: 'marketing-material', path: './marketing-material', children: [] },
      { name: 'info-center', path: './info-center', children: [] },
      { name: 'advisors', path: './advisors', children: [] },
      { name: 'organizations', path: './organizations', children: [] },
      { name: 'admin', path: './admin', children: [] },   
      { name: 'register', path: './register', children: [] },   
      { name: 'sign-up', path: './sign-up', children: [] },   
      { name: 'forgotPassword', path: './forgotPassword', children: [] }, 
      { name: 'resetPassword/:id', path: './resetPassword/:id', children: [] },   
      //{ name: 'resetPassword', path: './resetPassword', children: [{ name: 'user link', path: './', children:[]}] },      
      { 
        name: 'Illustrations', 
        path: './reports', 
        children: [
          {
            name: 'Search Clients',
            path: './create',
            children: [
              { 
                name: 'Healthcare Illustration',
                path: './hc'
              },
              { 
                name: 'Healthcare Illustration',
                path: './hc?am=1'
              },
              { 
                name: 'Social Security Illustration',
                path: './ss'
              },
              { 
                name: 'Medicare Means Testing Illustration',
                path: './mmtv2'
              },
              { 
                name: 'Long Term Care Illustration',
                path: './ltc'
              },
              { 
                name: 'Long Term Care Illustration',
                path: './ltc?am=1'
              }              
            ]
          }
        ] 
      },
    ];

    return menu;
  }

}